<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32 5.5H8C6.61929 5.5 5.5 6.61929 5.5 8V32C5.5 33.3807 6.61929 34.5 8 34.5H32C33.3807 34.5 34.5 33.3807 34.5 32V8C34.5 6.61929 33.3807 5.5 32 5.5ZM8 4C5.79086 4 4 5.79086 4 8V32C4 34.2091 5.79086 36 8 36H32C34.2091 36 36 34.2091 36 32V8C36 5.79086 34.2091 4 32 4H8Z"
      class="fill-current"
    />
    <path
      d="M19.659 16.5717C20.3142 16.5271 20.9846 16.4374 21.6427 16.4289C21.6979 16.4282 21.7427 16.473 21.7427 16.5282V20.9488C21.7427 23.9625 21.7594 25.4853 21.7929 25.5172C21.8431 25.5651 21.8849 25.589 21.9184 25.589C22.1654 25.7067 22.5006 25.7115 22.8313 25.6951C23.2007 25.6768 23.5 25.9606 23.5 26.3305C23.5 26.7003 23.2002 27.0002 22.8303 27.0002C21.277 27.0002 19.7233 27.0002 18.1697 27.0002C17.7998 27.0002 17.5 26.7003 17.5 26.3305C17.5 25.9606 17.7998 25.6651 18.1694 25.679C18.7257 25.7 19.2081 25.7077 19.4331 25.4933C19.4498 25.4774 19.4582 24.3771 19.4582 22.1926C19.4582 19.8964 19.4247 18.6686 19.3577 18.5091C19.3075 18.3656 19.2071 18.262 19.0565 18.1982C18.8222 18.0866 18.4289 18.0308 17.8766 18.0308C17.7241 18.0308 17.6004 17.9071 17.6004 17.7546V17.361C17.6004 16.985 17.8936 16.6743 18.269 16.6525L19.659 16.5717Z"
      class="fill-current"
    />
    <path
      d="M22 13.5C22 14.3284 21.3284 15 20.5 15C19.6716 15 19 14.3284 19 13.5C19 12.6716 19.6716 12 20.5 12C21.3284 12 22 12.6716 22 13.5Z"
      class="fill-current"
    />
  </svg>
</template>
